import React from 'react'
import PropTypes from 'prop-types'
import Grid from '../../../common/components/Grid'
import Typography from 'material-ui/Typography'
import {Button} from '../../../components'
import Paper from 'material-ui/Paper'
import Avatar from 'material-ui/Avatar'
import GridList, {GridListTile} from 'material-ui/GridList'
import Hidden from 'material-ui/Hidden'

import {item as text} from '../text'
import Container from '../../../common/components/Container'
import ErrorMessage from '../../../common/components/ErrorMessage'
import HeaderProgress from '../../../common/components/HeaderProgress'
import Rent from '../../rent/containers/orchestrator'

class Item extends React.Component {

  state = {
    picture: '',
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.item.size === 0 && nextProps.item.size !== 0) {
      let mainPicture = nextProps.item.get('Photos').find(picture => picture.MainPhoto === true)
      if (mainPicture) {
        this.setState({picture: mainPicture.Url})
      } else {
        this.setState({picture: '/assets/imagen_no_disponible.png'})
      }
    }
  }

  getTiles = w => {
    return this.props.item.get('Photos').map(picture => {
      return picture.Url + `?fit=fill&h=100&w=${w}`
    })
  }

  handleTileClick = url => {
    this.setState({picture: url.substring(0, url.indexOf('?'))})
  }

  renderCost = cost => {
    return <span>${cost}/día</span>
  }

  getMainImageSize = width => {
    switch (width) {
      case 'xs':
        return 400
      case 'sm':
        return 550
      case 'md':
        return 431
      case 'lg':
        return 594
      case 'xl':
        return 594
      default:
        return 594
    }
  }

  getSmallImageSize = width => {
    switch (width) {
      case 'xs':
        return 131
      case 'sm':
        return 135
      case 'md':
        return 105
      case 'lg':
        return 116
      case 'xl':
        return 116
      default:
        return 146
    }
  }

  getCols = width => {
    switch (width) {
      case 'xs':
        return 3
      case 'sm':
        return 4
      case 'md':
        return 4
      case 'lg':
        return 5
      case 'xl':
        return 5
      default:
        return 3
    }
  }

  render() {
    const {classes, width, item, error, isFetching} = this.props
    if (error !== '') return <ErrorMessage error={error}/>
    if (isFetching === true) return <HeaderProgress show={true}/>
    if (item.size === 0) return <ErrorMessage error={text.somethingWentWrong}/>
    return (
      <Container>
        <Rent/>
        <HeaderProgress show={isFetching}/>
        <Grid container spacing={0} style={{padding: width === 'lg' || width === 'xl' ? '0 160px' : 0}}>
          <Grid item xs={12} md={6}>
            <Hidden only={['xs']}>
              <Paper style={{minHeight: 400}}>
                <img
                  src={`${this.state.picture}?fit=fill&h=400&w=${this.getMainImageSize(width)}`}
                  alt={item.get('Name')}
                  width="100%"
                  height="400"
                  style={{objectFit: 'cover'}}
                />
              </Paper>
            </Hidden>
            <Hidden only={['sm', 'md', 'lg', 'xl']}>
              <Paper style={{minHeight: 320}}>
                <img
                  src={`${this.state.picture}?fit=fill&h=320&w=${this.getMainImageSize(width)}`}
                  alt={item.get('Name')}
                  width="100%"
                  height="320"
                  style={{objectFit: 'cover'}}
                />
              </Paper>
            </Hidden>
            <div className={classes.imgListContainer}>
              <GridList cols={this.getCols(width)} cellHeight={90} className={classes.imgList}>
                {this.getTiles(this.getSmallImageSize(width)).map((tile, key) => (
                  <GridListTile
                    key={key}
                    onClick={() => this.handleTileClick(tile)}
                    classes={{
                      root: classes.gridListTileRoot,
                      tile: classes.gridListTileTile,
                    }}
                  >
                    <Paper style={{width: '100%', height: '100%'}}>
                      <img src={tile} alt={tile} width={'100%'} height={'100%'} style={{objectFit: 'scale-down'}}/>
                    </Paper>
                  </GridListTile>
                ))}
              </GridList>
            </div>
          </Grid>
          <Grid item xs={12} md={6} style={{padding: 0}}>
            <div className={classes.itemDescriptionContainer}>
              <div>
                <Typography variant="headline" className={classes.name}>{item.get('Name')}</Typography>
                <Typography variant="body2" gutterBottom color={'textSecondary'}>{item.get('Product')}</Typography>
                <Typography variant="display1" className={classes.price}>
                  {this.renderCost(item.get('RentPrice'))}
                </Typography>
                <Typography variant="body1">{item.get('Description')}</Typography>
                <div style={{marginTop: 30, padding: '20px 0'}}>
                  <Button
                    variant="primary"
                    onClick={() => {
                      if (this.props.isLoggedIn === false) {
                        this.props.openLogin()
                      } else {
                        this.props.startRent(item)
                      }
                    }}
                    fullWidth={true}
                  >
                    {text.checkAvailability}
                  </Button>
                </div>
              </div>
              <div className={classes.itemAvatarContainer}>
                <Avatar
                  alt="Usuario"
                  src={item.get('OwnerData').ProfilePicture}
                  style={{width: 36, height: 36, margin: '0 0 0 auto'}}
                  imgProps={{style: {height: '100%', objectFit: 'cover'}}}
                />
                <div className={classes.itemOwnerNameContainer}>
                  <Typography type="subheading">
                    {text.publishedBy} {`${item.get('OwnerData').Name} ${item.get('OwnerData').LastName}`}
                  </Typography>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>
    )
  }

  static propTypes = {
    isFetching: PropTypes.bool,
    error: PropTypes.string,
    item: PropTypes.object,
    startRent: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    openLogin: PropTypes.func.isRequired,
  }
}

export default Item



// WEBPACK FOOTER //
// ./src/sections/items/components/item.js